import apiClient from './client';

export const linksApi = {
  getAll(params = {}) {
    return apiClient.get('/links', params);
  },

  getById(id) {
    return apiClient.get(`/links/${id}`);
  },

  getAnalytics(id, params = {}) {
    return apiClient.get(`/links/${id}/analytics`, params);
  },

  create(data) {
    return apiClient.post('/links', data);
  },

  update(id, data) {
    return apiClient.put(`/links/${id}`, data);
  },

  delete(id) {
    return apiClient.delete(`/links/${id}`);
  },
};

export default linksApi;
